import { Box } from '@mui/material';
import React from 'react';
import { DateRange } from './common';
import {
  fileTypes, minDate, report_type, reportTitles,
} from '../constants';
import { createReportRequest } from '../../../../api/reportApi';
import { useGetReport } from '../utils';
import { ReportTemplate } from './ReportTemplate';

const initialForm = {
  date_from: null,
  date_to: null,
  report_status: null,
};


export function EntitiesAcceptedReport() {
  const getReports = async ({ form }) => {
    try {
      return createReportRequest({
        format_type: fileTypes.xlsx,
        report_type,
        kind: reportTitles.list_entities_accepted_reporting,
        options: { ...form, report_status: form.report_status?.value },
      });
    } catch (e) {
      console.error(e);
    }
  };


  const {
    onChange,
    form,
    clear,
    makeRequest,
    dateError,
    isCleared,
    setIsCleared,
  } = useGetReport({
    initialForm,
    getReports,
    withDownload: true,
    withMinDate: true,
  });

  const {
    date_to,
    date_from,
  } = form;

  return (
    <ReportTemplate
      reportTitle="Период принятия отчета"
      clear={clear}
      visibleClear={date_from !== null || date_to !== null}
      error={dateError}
      downloadOptions={{ disableDownload: !date_to || !date_from, makeRequest }}
    >
      <Box sx={{ display: 'flex', gap: 2 }}>
        <DateRange
          date_to={date_to}
          date_from={date_from}
          onChange={onChange}
          minDate={minDate}
          isCleared={isCleared}
          setIsCleared={setIsCleared}
        />
      </Box>
    </ReportTemplate>
  );
}
